<template>
  <div id="pdf-header">
    <img class="qia-logo" :src="require(`@/assets/images/qia-logo-sm.png`)">
    <div class="mode">{{pdfHeaderData.mode}}</div>
    <p class="title">{{pdfHeaderData.title}}</p>
    <div class="owner-div">
      Owner: <span class="owner">{{pdfHeaderData.owner}}</span>
      Modify date: <span class="data">{{pdfHeaderData.modifyDate}}</span>
    </div>
    <div class="breadcrumb">{{pdfHeaderData.breadcrumb}}</div>
  </div>
</template>

<script>
  export default {
    name: "pdf-header",
    props: ['pdfHeaderData'],
  }
</script>

<style>
  img.qia-logo {
    float: left;
    margin-right: 20px;
    width: 62px;
    height: auto;
  }
  #pdf-header {
    text-align: right;
    font-weight: 500;
    display: none;
  }
  .mode {
    text-transform: uppercase;
    font-size: .8em;
		color: $color-text-grey !important;
  }
  .title {
    font-size: 1.3em;
    margin-bottom: 14px;
    color: $color-text-grey !important;
  }
  .owner,
  .data {
    min-width: 40px;
    font-size: 1em;
		color: $color-text-grey !important;
  }
  .owner {
    margin-right: 20px;
  }
  .owner-div {
    margin-bottom: -4px;
  }
  .owner-div,
  .breadcrumb {
    font-weight: 400;
    font-size: 1em;
    padding-right: 0px;
		color: $color-text-grey !important;
  }
</style>
